export default (state, { payload: { itemsType } }) => ({
  ...state,
  itemsType
});
